// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner__2TPaS","spinnerImage":"LoadingSpinner_spinnerImage__1e6A9"};